const INTRO_MUSIC_ID = 'intro-music';

class IntroMusicController {
  private muted = false;
  private unlocked = false;
  private wantsPlayback = true;

  prime(): void {
    const element = this.element;
    if (!element) return;
    this.wantsPlayback = true;
    element.preload = 'auto';
    element.volume = 0.5;
    element.muted = true;
    if (element.readyState === HTMLMediaElement.HAVE_NOTHING) element.load();
    void element.play().catch(() => {
      // A user gesture will retry playback through unlock().
    });
  }

  unlock(): void {
    this.unlocked = true;
    const element = this.element;
    if (!element) return;
    element.muted = this.muted;
    if (this.wantsPlayback && !this.muted) {
      void element.play().catch(() => {
        // Some embedded browsers can still deny media playback.
      });
    }
  }

  play(): void {
    const element = this.element;
    if (!element) return;
    this.wantsPlayback = true;
    element.muted = this.muted || !this.unlocked;
    element.volume = 0.5;
    void element.play().catch(() => {
      // unlock() retries from the first keyboard or pointer gesture.
    });
  }

  stop(): void {
    const element = this.element;
    if (!element) return;
    this.wantsPlayback = false;
    element.pause();
    element.currentTime = 0;
  }

  setMuted(muted: boolean): void {
    this.muted = muted;
    const element = this.element;
    if (!element) return;
    element.muted = muted || !this.unlocked;
    if (!muted && this.wantsPlayback) this.play();
  }

  get isPlaying(): boolean {
    const element = this.element;
    return Boolean(element && !element.paused && !element.ended && !element.muted && this.unlocked);
  }

  private get element(): HTMLAudioElement | null {
    return document.getElementById(INTRO_MUSIC_ID) as HTMLAudioElement | null;
  }
}

export const introMusic = new IntroMusicController();
